import React from "react";
import EditionEnrollmentModal from "./EditionEnrollmentModal";
import {
  closeEditionEnrollmentModal,
  useEditionEnrollmentTrigger,
} from "./store";

export const EditionEnrollmentHost: React.FC = () => {
  const trigger = useEditionEnrollmentTrigger();
  if (!trigger) return null;
  return (
    <EditionEnrollmentModal
      trigger={trigger}
      onClose={closeEditionEnrollmentModal}
    />
  );
};

export {
  openEditionEnrollmentModal,
  closeEditionEnrollmentModal,
} from "./store";
